import React, { Component, Fragment } from 'react'
import { LanguageConsumer, Translate } from '../../../contexts/LanguageContext';
import { Loading, BreadCrumb, Card, UserAccounts, Validator, ErrorMessage } from '../../../components';
import { Rules, PaymentConfirm, Currencies, TransferOptionUrl } from '../../../components/Payment';
import { PaymentService } from '../../../services/PaymentService';
import { Tooltip } from 'reactstrap';
import { TransferOptionService } from '../../../services/TransferOptionService';
import { WithdrawalService } from '../../../services/WithdrawalService';

export class NetellerWithdrawal extends Component {

    constructor(props) {
        super(props)

        this.Refs = React.createRef();

        this.state = {
            loading: true,
            confirm: false,
            tooltipAvailableMargin: false,
            success: false,
            paymentOptions: {
                acceptedCurrencies: [],
                description: "",
                rules: [],
                title: ""
            },
            netellerAccounts: [],
            availableMargin: 0,
            accountCurrency: "",
            // Payment Form
            login: 0,
            amount: 0,
            currency: "",
            accountID: "",
            validation: {
                error: false,
                message: ""
            }
        }

    }
    componentWillMount() {

        TransferOptionService.Withdrawal.OptionPage(TransferOptionUrl()).then(response => {

            if (!response) {
                document.location.href = "/withdrawal";
                return false;
            }

            
            this.setState({
                paymentOptions: response,
                error: false
            }, () => {
                PaymentService.Withdrawal.NetellerAccount().then(response => {

                    if (response) {
                        this.setState({
                            loading: false,
                            netellerAccounts: response
                        });

                    } else {
                        this.setState({
                            loading: false
                        });
                    }
                });
            });
        });
    }
    changeAccount(userAccount) {
        this.setState({
            login: userAccount.active,
            availableMargin: userAccount.info.availableMargin.toFixed(2),
            accountCurrency: userAccount.info.currency,
            currency:userAccount.info.currency,
            amount: 0
        });
    }
    onChangeForm(e, key) {

        let value = e.target.value;

        if (key === "amount" && parseFloat(value) > this.state.availableMargin)
            value = this.state.availableMargin;

        this.setState({
            [key]: value
        });
    }
    onAvailableMargin() {

        this.setState({
            amount: this.state.availableMargin
        });
    }
    onToggleWithdrawal() {
        if (this.isValid())
            this.setState(prevState => ({
                confirm: !prevState.confirm
            }));
    }
    isValid() {


        if (!this.state.confirm) {

            let error = Validator.Valid({ 
                amount: this.state.amount,
                accountID: this.state.accountID
            }, this.Refs);

            this.setState({
                validation: error
            });

            return !error.error;
        }

        return true;
    }

    onConfirmWithdrawal() {
        this.setState({ loading: true,validation: {
            error: false,
            message: ""
        } }, () => {

            WithdrawalService.Neteller({
                login: this.state.login,
                amount: this.state.amount,
                currency: this.state.currency,
                accountID: this.state.accountID
            }).then(response => {


                if (response) {
                    this.setState({
                        loading: false,
                        success: !response.error,
                        validation:{
                            error:response.error,
                            message:response.message
                        }
                    });
                } else {
                    this.setState({
                        loading: false,
                        validation: {
                            error: true,
                            message: "Temporary error!"
                        }
                    });
                }

            });

        });
    }
    render() {
        const netellerAccounts = this.state.netellerAccounts.map((item) => (
            <option key={item} value={item}>{item}</option>
        ));

        return (
            <LanguageConsumer>
                {() => (
                    <Fragment>
                        <Loading Show={this.state.loading} Title={Translate("Loading Content")} />
                        <BreadCrumb Title={this.state.paymentOptions.title} Name={this.state.paymentOptions.title} SubTitle={Translate("Withdrawal")} SubUrl="/withdrawal" />
                        <Card Title={this.state.paymentOptions.title} Description={this.state.paymentOptions.description} Logo={this.state.paymentOptions.logo}>
                            <div className="row">
                                <div className="col-md-12">
                                    <Rules Items={this.state.paymentOptions.rules} />
                                </div>
                                <ErrorMessage Validation={this.state.validation} />
                                {!this.state.confirm ?
                                    <div className="col-md-12">
                                        <form className="form-horizontal" name="depositForm" ref={this.Refs}>
                                            <h4 className="mt-0 header-title m-b-20 mt-4 text-dark"><i className="fas fa-file-invoice"></i>{Translate("&nbsp; Payment Form")}</h4>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="example-text-input" className="col-sm-2 col-form-label">{Translate("Account")}</label>
                                                <div className="col-sm-5">
                                                    <UserAccounts OnlyInfo Witdrawal className="bg-dark" Change={(e, userAccount) => this.changeAccount(userAccount)} />
                                                </div>
                                            </div>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="amount" className="col-sm-2 col-form-label">{Translate("Amount")}</label>
                                                <div className="col-sm-5">
                                                    <div className="input-group">
                                                        <input className="form-control" type="number" id="amount" value={this.state.amount} onChange={(e) => this.onChangeForm(e, "amount")} onFocus={e => e.target.select()} />
                                                        <div className="input-group-append hide">
                                                            <button type="button" className="input-group-text pt-0 pb-0 bg-white" id="availableMargin" onClick={(e) => this.onAvailableMargin()}>
                                                                {this.state.availableMargin + " " + this.state.accountCurrency}
                                                            </button>
                                                            <Tooltip placement="right" isOpen={this.state.tooltipAvailableMargin} target="availableMargin" toggle={() => this.setState({ tooltipAvailableMargin: !this.state.tooltipAvailableMargin })}>
                                                                {Translate("Available Margin")}
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="currency" className="col-sm-2 col-form-label">{Translate("Currency")}</label>
                                                <div className="col-sm-5">
                                                    <Currencies Items={[this.state.currency]} onChange={(e) => this.onChangeForm(e, "currency")} />
                                                </div>
                                            </div>
                                            <h4 className="mt-0 header-title m-b-20 mt-4 text-dark"><i className="fas fa-user-alt"></i>{Translate("&nbsp; Neteller Account")}</h4>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="accountID" className="col-sm-2 col-form-label">{Translate("Account ID")}</label>
                                                <div className="col-sm-5">
                                                    <select className="form-control" id="accountID" value={this.state.accountID} onChange={(e) => this.onChangeForm(e, "accountID")}>
                                                        <option value="-1">{Translate("Select Neteller Account")}</option>
                                                        {netellerAccounts}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="example-text-input" className="col-sm-2 col-form-label"></label>
                                                <div className="col-sm-5">
                                                    <button type="button" className="btn btn-lg btn-success" onClick={(e) => this.onToggleWithdrawal()}>{Translate("Create a Withdrawal Request")}</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    :
                                    <PaymentConfirm Form={[
                                        {
                                            title: Translate("Account"),
                                            value: this.state.login
                                        },
                                        {
                                            title: Translate("Amount"),
                                            value: this.state.amount.format('C') + " " + this.state.currency
                                        },
                                        {
                                            title: Translate("Account ID"),
                                            value: this.state.accountID
                                        }
                                    ]} Cancel={(e) => this.onToggleWithdrawal()} Confirm={(e) => this.onConfirmWithdrawal()} Success={this.state.success} CancelButtonTitle={Translate('Cancel Withdrawal')} ConfirmButtonTitle={Translate('Confirm Withdrawal')} />
                                }
                            </div>
                        </Card>
                    </Fragment>
                )}
            </LanguageConsumer>
        )
    }
}